import { API_BASE } from "./apiBase.ts";

function addLockedParams(returnTo: string, initialParams?: Record<string, any>) {
  if (!initialParams) return returnTo;

  // preserve hash (#refresh=...)
  const [pathAndQuery, hash] = returnTo.split("#");
  const u = new URL(pathAndQuery, "http://local"); // dummy base

  for (const [k, v] of Object.entries(initialParams)) {
    if (v == null) continue;

    // Metabase usually handles repeated keys for multi-select
    if (Array.isArray(v)) {
      u.searchParams.delete(k);
      v.forEach((x) => u.searchParams.append(k, String(x)));
    } else {
      u.searchParams.set(k, String(v));
    }
  }

  return `${u.pathname}${u.search}${hash ? `#${hash}` : ""}`;
}

export async function getEmbedUrl(
  resource: any,
  accessToken: string,
  email?: string,
  themeMode: "dark" | "light" = "dark",
  embedParams?: { initialParameters?: Record<string, any> } | null // ✅ add
) {
  const refreshSec = resource?.refreshSec;
  const mbTheme = themeMode === "dark" ? "night" : "default";
  const dashboardId =
    typeof resource?.dashboard === "number"
      ? resource.dashboard
      : typeof resource?.entityId === "number"
      ? resource.entityId
      : null;

  let params: URLSearchParams;

  if (dashboardId) {
    let return_to =
      `/dashboard/${dashboardId}` +
      `?theme=${encodeURIComponent(mbTheme)}` +
      `&logo=false&top_nav=false&side_nav=false&header=false&action_buttons=false&downloads=true` +
      (refreshSec ? `#refresh=${refreshSec}` : "");

    // ✅ inject airport (and other locks) here
    return_to = addLockedParams(return_to, embedParams?.initialParameters);

    params = new URLSearchParams({ return_to });
  } else {
    params = new URLSearchParams({ resource: JSON.stringify(resource) });
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  };
  if (email) headers["X-User-Email"] = email;

  const res = await fetch(`${API_BASE}/api/embed-url?${params.toString()}`, {
    method: "GET",
    headers,
    cache: "no-store",
  });

  if (!res.ok) throw new Error(`embed-url ${res.status}`);
  return res.text();
}
